import {VStack} from 'platform/foundation';
import styled from 'styled-components';

import {ReactNode} from 'react';

interface FinancialProductResultPanelProps {
  children: ReactNode;
}

export function FinancialProductResultPanel(props: FinancialProductResultPanelProps) {
  return (
    <ResultPanel>
      <VStack spacing={5} height="100%" grow={1}>
        {props.children}
      </VStack>
    </ResultPanel>
  );
}

const ResultPanel = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({theme}) => theme.getSize(6)};
  height: 100%;
  min-height: ${({theme}) => theme.getSize(40)};
  background: ${({theme}) => theme.colors.accent.darkest};
  background: ${({theme}) => `linear-gradient(
    145deg,
    color-mix(
      in srgb,
      ${theme.colors.accent.base} 30%,
      color-mix(in srgb, ${theme.colors.text.secondary} 65%, ${theme.colors.accent.darkest})
    ) 0%,
    color-mix(
      in srgb,
      ${theme.colors.accent.base} 12%,
      color-mix(in srgb, ${theme.colors.text.secondary} 32%, ${theme.colors.accent.darkest})
    ) 48%,
    ${theme.colors.accent.darkest} 100%
  )`};
`;
